import React from "react";

/** Official-style platform marks — gradient fills, no enclosing buttons. */

export function AppleMusicLogo({ className = "w-20 h-20" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="am-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FB5C74" />
          <stop offset="55%" stopColor="#FA233B" />
          <stop offset="100%" stopColor="#8A3AB9" />
        </linearGradient>
      </defs>
      <path
        fill="url(#am-grad)"
        d="M33.2 3.9c.9-.2 1.8.5 1.8 1.5v22.3c0 4-3.2 6.9-7.4 6.9-3.5 0-6.3-2.4-6.3-5.6 0-3.2 2.7-5.5 6.3-5.5 2 0 3.7.7 4.8 1.8V13.6c0-.6-.5-1-1.1-.9L17 15.9c-.5.1-.9.6-.9 1.2v15.5c0 4-3.2 6.9-7.4 6.9-3.5 0-6.3-2.4-6.3-5.6 0-3.2 2.7-5.5 6.3-5.5 2 0 3.7.7 4.8 1.8V13c0-1.7 1.2-3.1 2.9-3.4l15.8-3.5.9-.2z"
      />
    </svg>
  );
}

export function SpotifyLogo({ className = "w-20 h-20" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <circle cx="24" cy="24" r="22.5" fill="#1ED760" />
      <g stroke="#0A0A0C" strokeWidth="4.4" strokeLinecap="round" fill="none">
        <path d="M13.2 18.3c7.2-2.1 15-1.4 21.2 2.1" />
        <path d="M14.8 25.6c6.2-1.8 12.8-1.2 18 1.8" />
        <path d="M16.4 32.4c5.1-1.5 10.5-1 14.9 1.5" />
      </g>
    </svg>
  );
}

export function YouTubeLogo({ className = "w-20 h-20" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path
        fill="#FF0000"
        d="M45.9 14.5c-.5-2-2.1-3.6-4.1-4.1C38.2 9.6 24 9.6 24 9.6s-14.2 0-17.8.8c-2 .5-3.6 2.1-4.1 4.1C1.3 18.1 1.3 24 1.3 24s0 5.9.8 9.5c.5 2 2.1 3.6 4.1 4.1 3.6.8 17.8.8 17.8.8s14.2 0 17.8-.8c2-.5 3.6-2.1 4.1-4.1.8-3.6.8-9.5.8-9.5s0-5.9-.8-9.5zM19.6 30.7V17.3L30.9 24l-11.3 6.7z"
      />
    </svg>
  );
}

export function InstagramLogo({ className = "w-20 h-20" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="ig-grad" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="#FFDD55" />
          <stop offset="28%" stopColor="#FF543E" />
          <stop offset="58%" stopColor="#C837AB" />
          <stop offset="100%" stopColor="#7638FA" />
        </linearGradient>
      </defs>
      <g fill="none" stroke="url(#ig-grad)" strokeWidth="3.6">
        <rect x="5.8" y="5.8" width="36.4" height="36.4" rx="11.5" />
        <circle cx="24" cy="24" r="9.2" />
      </g>
      <circle cx="34.6" cy="13.4" r="2.7" fill="url(#ig-grad)" />
    </svg>
  );
}
